import { useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { useMenu } from '@entities/Menu'


import { useCategoriesModal } from '@widgets/modal-categories/hooks/useCategoriesModal'

import { CATALOG_LINE_MENU_CODE } from '@shared/contants'
import { cn } from '@shared/lib/cn'

import { ProductGroupMenuButton } from './ProductGroupMenuButton'
import { ProductGroupMenuItem } from './ProductGroupMenuItem'

import styles from './styles.module.scss'

export default function ProductGroupMenu ({ className } : { className: string }) {
  const { t: tn } = useTranslation('navigation')

  const { openModal, isOpen } = useCategoriesModal()
  const { menu } = useMenu({ code: CATALOG_LINE_MENU_CODE })

  const catalogButtonRef = useRef<HTMLButtonElement>(null)

  const handleCategoriesClick = () => {
    openModal({
      options: {
        hideIconClose: true,
        disabledScroll: true,
        classes: {
          body: styles['modal-body--centered'],
          content: styles['modal-content--categories'],
        },
      }
    })
  }

  return (
    <div className={cn(styles.menuContainer, className)}>
      <div className={styles.catalogButtonContainer}>
        <ProductGroupMenuButton
          ref={catalogButtonRef}
          title={tn('catalog')}
          onClick={handleCategoriesClick}
          className={styles.productGroupMenu__button}
          isActive={isOpen}
        />
      </div>

      <div className={styles.scrollableMenuItemsContainer}>
        {menu?.menuItems.map((item) => (
          <ProductGroupMenuItem
            key={`product-group-menu-item-${item.id}`}
            title={item.title}
            url={item.link_url!}
            icon={item.icon_url}
            category={item.id}
          />
        ))}
      </div>
    </div>
  )
}
